import styled from 'styled-components';

const ServiceIndividualStyle = styled.section`
	.ContainerWrap {
		margin-bottom: var(--sectionToSection) !important;

		.item-2 {
			display: block !important;
		}
	}

	.tableWrap.underline {
		padding-top: var(--textToDescription);
	}

	.why-choose-item {
		&:not(:first-child) {
			margin-top: var(--titleToText);
		}
	}

	&.singleServices {
		--animationSize: 165px;
		--leftMarg: var(--sp8x);
		--bottomMarg: -18px;

		.servicesTop {
			.title {
				letter-spacing: -1px;

				span:first-child {
					margin-left: var(--leftMarg);
					display: block;
					margin-bottom: var(--bottomMarg);
				}
			}

			.servicesTitle {
				position: relative;

				.servicesCounter {
					position: absolute;
					top: 0;
					left: 0;
					transform: translateY(-65%);
				}
			}

			.servicesAnimationWrap {
				margin: var(--sp2x) 0 var(--sp5x);
				display: flex;
				justify-content: flex-end;
				height: var(--animationSize);
			}

			.portfolioRow {
				margin-left: calc(-1 * var(--containerPaddingLR));
				margin-right: calc(-1 * var(--containerPaddingLR));
			}
		}

		.workProcessItemsWrap {
			.workProcessItems {
				padding-top: var(--titleToText);
				border-top: 2px solid var(--color2);
				margin-bottom: var(--titleToContent);

				.iconCont {
					margin-bottom: var(--sp2x);
				}

				.infoCont {
					position: relative;

					.titleWrap {
						display: flex;

						.title {
							width: 77%;
						}

						.icon {
							width: 33%;
							position: relative;
						}
					}
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			--leftMarg: var(--sp15x);
			--bottomMarg: -47px;
			--animationSize: 140px;

			.servicesTop {
				.servicesAnimationWrap {
					margin: 0 0 calc(var(--sp4x) * -1);
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			.workProcessItemsWrap {
				.workProcessItems {
					display: flex;

					.iconCont {
						flex: 0 0 15%;

						.icon {
							position: relative;
							padding-top: 50%;
						}
					}

					.infoCont {
						flex: 1 1 auto;

						.titleWrap {
							.title {
								width: auto;
							}
						}
					}
				}
			}

			.servicesTop {
				.servicesTitle {
					.servicesCounter {
						transform: translateY(-50%);
					}
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
			--leftMarg: var(--sp13x);
			--bottomMarg: -47px;
			--animationSize: 165px;
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
			.workProcessItemsWrap {
				display: flex;
				flex-wrap: wrap;
				margin-left: calc(var(--sp2x) * -1);
				margin-right: calc(var(--sp2x) * -1);

				.workProcessItems {
					flex: 0 0 50%;
					max-width: calc(50% - var(--sp4x));
					margin-left: var(--sp2x);
					margin-right: var(--sp2x);

					.iconCont {
						flex: 0 0 24%;
					}
				}
			}

			.servicesTop {
				position: relative;

				.servicesAnimationWrap {
					position: absolute;
					bottom: var(--sp3x);
					right: 0;
					margin: 0;
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
			--leftMarg: var(--sp15x);
			--bottomMarg: -55px;
			--animationSize: 220px;
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
			--leftMarg: var(--sp17x);
			--bottomMarg: -68px;
			--animationSize: 250px;
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
			--leftMarg: var(--sp21x);
			--bottomMarg: -100px;
			--animationSize: 330px;
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
			--leftMarg: var(--sp27x);
			--bottomMarg: -125px;
			--animationSize: 350px;

			.workProcessItemsWrap {
				.workProcessItems {
					max-width: calc(50% - var(--sp12x));
					margin-left: var(--sp6x);
					margin-right: var(--sp6x);
				}
			}
		}
	}
`;

export default ServiceIndividualStyle;
